module.exports = __webpack_public_path__ + "static/media/login-bg.e8197fd5.png";